// 路由列表汇总
import { lazy } from 'react';
const Home = lazy(() => import('../../pages/Home'));
const AccessInternet = lazy(() => import('../../pages/AccessInternet'));
const AccessSuccess = lazy(() => import('../../pages/AccessSuccess'));
const AccessFail = lazy(() => import('../../pages/AccessFail'));
const EmptyPage = lazy(() => import('../../pages/EmptyPage'));
const JSSHLoadingPage = lazy(() => import('../../pages/JSSHLoadingPage'));
const NationalLoadingPage = lazy(() => import('../../pages/NationalLoadingPage'));
const Health = lazy(() => import('../../pages/Health'));
const HzMonitor = lazy(() => import('../../pages/Common'));

const Entrance = lazy(() => import('../../universalPages/Entrance'));
const MHome = lazy(() => import('../../universalPages/MHome'));
const MAccessInternet = lazy(() => import('../../universalPages/MAccessInternet'));
// const MAccessInternetV25 = lazy(() => import('../../universalPages/MAccessInternetV24_backup/index'));
const ExecutePass = lazy(() => import('../../universalPages/ExecutePass'));
const MAccessSuccess = lazy(() => import('../../universalPages/MAccessSuccess'));
const MAccessFail = lazy(() => import('../../universalPages/MAccessFail'));
const MAuth = lazy(() => import('../../universalPages/MAuth'));
const MAuthSuccess = lazy(() => import('../../universalPages/MAuthSuccess'));
const MAuthFail = lazy(() => import('../../universalPages/MAuthFail'));
const PCHome = lazy(() => import('../../universalPages/PCHome'));
const PCSuccess = lazy(() => import('../../universalPages/PCSuccess'));
const PCFail = lazy(() => import('../../universalPages/PCFail'));


export const routes = {
	'/excutepass': { //放行
        component: ExecutePass,
        exact: true,
    },

    '/entrance': { //挂参入口
        component: Entrance,
        exact: true,
    },
    
    '/main': { //挂参入口
        component: Entrance,
        exact: true,
    },

    '/mhome': { //h5首页
        component: MHome,
        exact: true,
    },

    '/maccessinternet': { //h5填验证码页
        component: MAccessInternet,
        exact: true,
    },
    // '/maccessinternetv25': { //h5填验证码页
    //     component: MAccessInternetV25,
    //     exact: true,
    // },

    '/maccesssuccess': { //h5成功
        component: MAccessSuccess,
        exact: true,
    },

    '/maccessfail': { //h5失败
        component: MAccessFail,
        exact: true,
    },
	'/menaccesssuccess': { //英文h5成功
        component: MAccessSuccess,
        exact: true,
    },
    '/menaccessfail': { //英文h5失败
        component: MAccessFail,
        exact: true,
    },

    '/mauth': { //h5授权
        component: MAuth,
        exact: true,
    },
    '/mauthsuccess': { //h5授权成功
        component: MAuthSuccess,
        exact: true,
    },
    '/mauthfail': { //h5授权失败
        component: MAuthFail,
        exact: true,
    },
	'/pchome': { //
        component: PCHome,
        exact: true,
    },
    '/pcaccesssuccess': { //pc成功
        component: PCSuccess,
        exact: true,
    },
    '/pcaccessfail': { //pc失败
        component: PCFail,
        exact: true,
    },
    '/pcenaccesssuccess': { //英文pc成功
        component: PCSuccess,
        exact: true,
    },
    '/pcenaccessfail': { //英文pc失败
        component: PCFail,
        exact: true,
    },
    '/': {
        component: Home,
        exact: true,
    },
    '/accessinternet': {
        component: AccessInternet,
        exact: true,
    },
    '/accesssuccess': {
        component: AccessSuccess,
        exact: true,
    },
    '/accessfail': {
        component: AccessFail,
        exact: true,
    },
    '/emptypage': {
        component: EmptyPage,
        exact: true,
    },
    '/jsshloadingpage': {
        component: JSSHLoadingPage,
        exact: true,
    },
    '/nationalloadingpage': {
        component: NationalLoadingPage,
        exact: true,
    },
    '/actuator/health': {
        component: Health,
    },
    '/common/hzMonitor': {
        component: HzMonitor,
    },
    '/common/hzMonitor/': {
        component: HzMonitor,
    }
};
